import CommitWorkflowStepById from 'ia-react-core/~/actions/workflow/CommitWorkflowStepById';
import CommitWorkflowStepByName from 'ia-react-core/~/actions/workflow/CommitWorkflowStepByName';
import { CoreAction } from 'ia-react-core/~/interfaces/CoreAction';
import commitWorkflowStepById from '../../../actions/workflow-fn/commitWorkflowStepById';
import commitWorkflowStepByName from '../../../actions/workflow-fn/commitWorkflowStepByName';
import { WorkflowComposedProps } from './Workflow';

export default function workflowValuesReducer(state: Record<string, any>, action: CoreAction, { workflowId, name }: WorkflowComposedProps) {
  switch (action.type) {
    case `${commitWorkflowStepById.type}/${workflowId}`:
      return reduceCommitStep(state, action as CommitWorkflowStepById);
    case `${commitWorkflowStepByName.type}/${name}`:
      return reduceCommitStep(state, action as CommitWorkflowStepByName);
    default:
      return state;
  }
}

function reduceCommitStep(state: Record<string, any>, { stepName, values }: CommitWorkflowStepById | CommitWorkflowStepByName) {
  return {
    ...state,
    [stepName]: values,
  };
}
